
import { MapToPackageUploadMetadataType, UpdateClassification, Version } from "../infrastructure/types/firmware-upload.types";

export function parseVersionString(value: string) {
  const versionPartsArray = value.split(",");
  const versionIdAndHardwareParts = versionPartsArray[0];
  const majorMinorDevelopParts = versionPartsArray[1];

  const versionIdAndHardwareArray = versionIdAndHardwareParts.split("-");
  const cpNumber = Number(versionIdAndHardwareArray[0]) || 0;
  const hardwareId = Number(versionIdAndHardwareArray[1]) || 0;

  const majorMinorDevelopVersions = majorMinorDevelopParts.split(".");
  const major = Number(majorMinorDevelopVersions[0]) || 0;
  const minor = Number(majorMinorDevelopVersions[1]) || 0;
  const develop = Number(majorMinorDevelopVersions[2]) || 0;

  return { cpNumber, hardwareId, major, minor, develop };
}

export function mapReleaseNotesToPlainObjects(releaseNotesRaw: string) {
  if (!releaseNotesRaw) return [];

  try {
    let parsed = JSON.parse(releaseNotesRaw);

    // if notes is string, parse again
    if (typeof parsed.notes === "string") {
      parsed = JSON.parse(parsed.notes);
    }

    const actualNotes = parsed.notes;

    if (!actualNotes || typeof actualNotes !== "object") return [];

    return Object.entries(actualNotes).map(([languageCode, text]) => ({
      languageCode,
      text: text as string,
    }));
  } catch {
    return [];
  }
}

export function mapToUpdateAccess(value: string): string {
  switch (value) {
    case "Update by CPO":
      return 'Cpo';
    case "Update by CPO & end-user":
      return 'CpoAndUser';
    default:
      return 'Cpo';
  }
}

function mapSupportedCompanionApps(
  apps: {
    name: string;
    appleMinimumVersion: string;
    androidMinimumVersion: string;
  }[] = []
) {
  return apps.map(app => ({
    name: app.name,
    appleMinimumVersion: app.appleMinimumVersion,
    androidMinimumVersion: app.androidMinimumVersion,
  }));
}

export function mapToUpdateClassification(value: string): UpdateClassification {
  switch (value.toLowerCase()) {
    case "critical update":
      return UpdateClassification.Critical;
    case "major update":
      return UpdateClassification.Major;
    case "minor update":
      return UpdateClassification.Minor;
    default:
      return UpdateClassification.Critical;
  }
}

export function mapToPackageUploadMetadata(input: MapToPackageUploadMetadataType) {
  return {
    distribution: {
      access: mapToUpdateAccess(input.distribution.access),
      supportedCompanionApps: mapSupportedCompanionApps(input.distribution.supportedCompanionApps),
    },

    packageMetadata: {
      classification: mapToUpdateClassification(input.packageMetadata.classification),
      packageName: input.packageMetadata.packageName,
    },
    compatibleVersions: Array.isArray(input.deviceCompatibility.compatible_device_software_versions)
      ? input.deviceCompatibility.compatible_device_software_versions.map((version: Version) => {
          const parsedVersion = parseVersionString(version.value);
          return {
            cpNumber: parsedVersion.cpNumber,
            hardwareId: parsedVersion.hardwareId,
            major: parsedVersion.major,
            minor: parsedVersion.minor,
            develop: parsedVersion.develop,
          };
        })
      : [],
    releaseNotes: mapReleaseNotesToPlainObjects(input.releaseNotes.release_notes || ""),
  };
}

